export const BOOK_STATUS = [
  {
      eventKey: '0',
      label: 'Status'
  },
  {
      eventKey: '1',
      label: 'Lendo'
  },
  {
      eventKey: '2',
      label: 'Quero ler'
  },
  {
      eventKey: '3',
      label: 'Lidos'
  },
];

export const getBookStatus = (eventKey) => {
    return BOOK_STATUS.find(status => status.eventKey === eventKey);
};
